import { userService } from '../../helpers/fakebackend/user.service';
import router from '../../router/index'

const user = JSON.parse(localStorage.getItem('user'));
export const state = user
    ? { status: { loggeduser: true }, user }
    : { status: {}, user: null };

export const actions = {
    // Logs in the user.
    login({ dispatch, commit }, { email, password }) {
        commit('loginRequest');

        userService.login(email, password)
            .then(
                user => {
                    commit('loginSuccess', user);
                    router.push('/');
                },
                error => {
                    commit('loginFailure', error);
                    dispatch('notification/error', error, { root: true });
                }
            );
    },
    // Logout the user
    logout({ commit }) {
        userService.logout();
        commit('logout');
    },
    // register the user
    registeruser({ dispatch, commit }, user) {
        commit('registerRequest', user);
        userService.register(user)
            .then(
                user => {
                    commit('registerSuccess', user);
                    dispatch('notification/success', 'Registration successful', { root: true });
                    router.push('/login');
                },
                error => {
                    commit('registerFailure', error);
                    dispatch('notification/error', error, { root: true });
                }
            );
    },

    refreshCurrentUser({ commit, dispatch }) {
        return userService.getCurrentUser()
            .then(
                user => {
                    commit('setCurrentUser', user);
                    return user;
                },
                error => {
                    dispatch('notification/error', error, { root: true });
                    throw error;
                }
            );
    }
};

export const mutations = {
    loginRequest(state) {
        state.status = { loggingIn: true };
    },
    loginSuccess(state, user) {
        state.status = { loggeduser: true };
        state.user = user.result;
    },
    loginFailure(state) {
        state.status = {};
        state.user = null;
    },
    logout(state) {
        state.status = {};
        state.user = null;
    },
    registerRequest(state) {
        state.status = { registering: true };
    },
    registerSuccess(state, user) {
        state.status = {};
        state.user = user.result;
    },
    registerFailure(state) {
        state.status = {};
    },

    setCurrentUser(state, user) {
        state.user = user;
    }
};

